// @flow
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ProcessingLoader from 'components/shared/ProcessingLoader/ProcessingLoader';
import CardGoal from 'components/shared/Goal/index';
import ShareGoalPopUp from 'components/shared/ShareGoal';
import userActions from 'actions/user';
import Supporters from 'components/shared/Supporters/index';
import { sendAnalyticsPath } from 'utils/analyticsWrapper';
import ErrorPopUp from 'components/shared/ErrorPopUp/ErrorPopUp';
import Header from './Header';
import Facts from './Facts/index';
import { PageContainer, GoalContainer, CardContainer } from './Styles';

const PublicGoalPage = (props: Props) => {
  const { userName, goalName } = useParams();
  const browserHistory = useHistory();
  const { t } = useTranslation();
  const {
    goal,
    error,
    isProcessing,
    user,
  } = props;
  const showContent = goal !== undefined;
  const hasError = error !== undefined;

  const { investors } = goal || [];

  const location = useLocation();

  const [showSharerPopUp, toggleShowSharerPopUp]: [any,
    ((any => any) | any) => void] = useState(location.pathname.includes('share'));

  const [errorPopUp, setErrorPopUp]: [any,
      ((any => any) | any) => void] = useState({ show: false });

  const onCloseSharerPopUp = () => {
    toggleShowSharerPopUp(false);
  };

  const fetchInformation = () => {
    sendAnalyticsPath('user/username/goal');

    props.getInformation(userName, goalName)
      .catch(() => {
        setErrorPopUp({ ...errorPopUp, show: true });
      });
  };

  useEffect(() => {
    //reset page scroll when user scrolled down before
    window.scrollTo(0, 0); 
    
    if (goal || goalName === 'share') {
      return;
    }
    fetchInformation();
  }, []);

  if (isProcessing) {
    return <ProcessingLoader show />;
  }

  // if (hasError) {
  //   browserHistory.push('/notfound');
  // }

  if (!showContent) {
    return (
      <ErrorPopUp
        show={errorPopUp.show}
        onBack={() => {
          setErrorPopUp({ ...errorPopUp, show: false });

          browserHistory.push(`/user/${userName}`);
        }}
      />
    );
  }

  return (
    <>
      <Header name={user.firstname.trim()} />
      <PageContainer>
        <GoalContainer>
          <CardContainer>
            <CardGoal data={goal} owner={user} color="steelblue" aloneView />
          </CardContainer>
        </GoalContainer>
      </PageContainer>
      <Facts />
      <Supporters title={t('supporters_text_title')} data={investors} />

      <ShareGoalPopUp show={showSharerPopUp} onClose={onCloseSharerPopUp} />
    </>
  );
};

// Map Props
const mapStateToProps = (state) => ({
  isProcessing: state.publicProfile.isProcessing,
  user: state.publicProfile.information,
  goal: state.publicProfile.goal,
  error: state.publicProfile.error,
});

// Map Dispatch
const mapDispatchToProps = (dispatch) => ({
  getInformation:
    (userName: string, goalName: string) => dispatch(
      userActions.getPublicInformation(userName, goalName),
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PublicGoalPage);
